import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Text } from "@mantine/core";

import classes from "./BotListeningLoader.module.css";
import src from "./listeningLottie.json?url";

function BotListeningLoader() {
    return (
        <>
            <DotLottieReact src={src} className={classes.player} loop autoplay speed={1} />
            <Text c="dark.2" className={classes.text} fs="italic" fz="sm">
                Listening...
            </Text>
        </>
    );
}
export default BotListeningLoader;
